import * as yup from 'yup';
import { THANKS_MESSAGES_TYPES } from 'constants/catalogs/thanksMessagesTypes';

export const DEFAULT_VALUE_THANKS_MSG = `Estimado $INVITADO
Muchas gracias por tu regalo....
Tes esperamos en $EVENTO, el próximo $FECHA
Con cariño $FESTEJADO`;

export const mapPropsToValues = ({ tableInfo = {} } = {}) => {
  const { thanks_message = {}, showing_purchased_products = false } = tableInfo;
  return {
    messageType: THANKS_MESSAGES_TYPES.MESSAGE_BY_ORDER,
    thanksMessage: `${thanks_message.message || DEFAULT_VALUE_THANKS_MSG}`,
    keepShowingProducts: showing_purchased_products
  };
};

export const validationSchema = yup.object().shape({
  messageType: yup.string().nullable(),
  thanksMessage: yup.string().required('El campo es requerido'),
  keepShowingProducts: yup.bool()
});

export const THANKS_MESSAGE_OPTIONS = [
  { id: 1, text: '$INVITADO' },
  { id: 2, text: '$EVENTO' },
  { id: 3, text: '$FECHA' },
  { id: 4, text: '$FESTEJADO' }
];
